import { render, staticRenderFns } from "./itemGroupTwo.vue?vue&type=template&id=52f0c45c"
import script from "./itemGroupTwo.vue?vue&type=script&lang=js"
export * from "./itemGroupTwo.vue?vue&type=script&lang=js"
import style0 from "./itemGroupTwo.vue?vue&type=style&index=0&id=52f0c45c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports